// extracted by mini-css-extract-plugin
export default {"LoadError":"bew_a bhj_qq bhj_a bhj_w bhj_j bhj_q","LoadError__icon":"bew_b bhj_vj bhj_fk bhj_su","LoadError__message":"bew_c bhj_fk bhj_tp"};